import util from '@bmp-vue/core/api/util'

const controller = 'TransferirDinheiro'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']))
